import axiosInstance from './axios';
import * as LocalStorageService from '../utils/localStorageService';
import { API_ENDPOINTS } from '../utils/constants';

/**
 * This function is used to get all the hosts data
 *
 * @param {string} params query params to pass in the api call
 * @return {object} response object
 */
export const getAllHostsData = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `/api/v1/all-hosts/${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};

/**
 * This function is used to get all the products data
 *
 * @param {string} params query params to pass in the api call
 * @return {object} response object
 */

export const getAllProductsData = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `/api/v1/all-products/${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};
export const getAllStoresData = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `/api/v1/get-all-stores/${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};

/**
 * This function is used to get all the meeting takeaways data
 *
 * @param {string} params query params to pass in the api call
 * @return {object} response object
 */

export const getDemoTakeaways = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `${API_ENDPOINTS.GET_UNIQUE_QUESTIONS}${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};

/**
 * This function is used to get unique pros and cons data for host
 *
 * @param {string} params query params to pass in the api call
 * @return {object} response object
 */

export const getUniqueHostProsAndCons = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `${API_ENDPOINTS.GET_UNIQUE_PROS_CONS}${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};

/**
 * This function is used to get unique pros and cons data for guest
 *
 * @param {string} params query params to pass in the api call
 * @return {object} response object
 */

export const getUniqueGuestProsAndCons = async (params) => {
  return await axiosInstance({
    method: 'get',
    url: `${API_ENDPOINTS.GET_UNIQUE_PROS_CONS}${params}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + LocalStorageService.getAccessToken(),
      devicetype: 'web',
    },
  });
};
